import {useLocale} from '@aboutyou/i18n';
import React from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {tabletAndUp} from '../../../../constants/customMedia';
import {Icon} from '../../../atoms/Icon/Icon';
import {AY_ANNIVERSARY_LOGO_MAP} from '../utils/ayAnniversaryLogoMap';

export const AboutYouAnniversaryLogo: React.FC<{
  showFullLogo?: boolean;
}> = ({showFullLogo}) => {
  const locale = useLocale();
  const ayAnniversaryLogo = AY_ANNIVERSARY_LOGO_MAP[locale];

  if (!ayAnniversaryLogo) {
    return null;
  }

  return showFullLogo ? (
    <FullLogo
      data-testid="SVGLogo"
      asset={ayAnniversaryLogo.fullLogo.iconName}
      fill={COLORS.Black}
    />
  ) : (
    <Logo
      $ratio={ayAnniversaryLogo.logo.ratio}
      asset={ayAnniversaryLogo.logo.iconName}
      fill={COLORS.Black}
    />
  );
};

const FullLogo = styled(Icon)`
  width: 100%;
  max-width: 140px;
  height: 26px;
`;

const Logo = styled(Icon)<{$ratio: `${number}/${number}`}>`
  aspect-ratio: ${props => props.$ratio};
  height: 18px;
  margin-right: 4px;

  ${tabletAndUp(
    css`
      height: 23px;
    `,
  )}
`;
